export function newPrayer(prayer) {
  return {
    type: "NEW_PRAYER",
    data: prayer
  };
}

export function editPrayer(prayer) {
  return {
    type: "EDIT_PRAYER",
    data: prayer
  };
}
export function hideModal() {
  return {
    type: "HIDE_PRAYER_MODAL"
  };
}



// WEBPACK FOOTER //
// ./src/actions/prayers.js